// extracted by mini-css-extract-plugin
module.exports = {"back":"Order_back__2UZ7r","space":"Order_space__2mkW3","bottom":"Order_bottom__gb3xc","pad":"Order_pad__JoiYo","error":"Order_error__2Go8y"};